// Bundled snapshot of both directories. This is the seed loaded into the shared Neon
// DB and the offline fallback the client returns when the API is unreachable, so a
// shared-DB/API outage can never hard-break checkout or mortgage-packet routing.
// The Neon copy (kept fresh by the weekly automation) is the source of truth; this
// snapshot only changes when someone edits the JSON directly.
import type { MortgageLookup, MortgageServiceContact } from './types';
import mortgageLookupsData from './data/mortgageLookups.json';
import mortgageServiceContactsData from './data/mortgageServiceContact.json';

export const bundledMortgageLookups: MortgageLookup[] = mortgageLookupsData as MortgageLookup[];

export const bundledMortgageServiceContacts: MortgageServiceContact[] =
  mortgageServiceContactsData as MortgageServiceContact[];
